import createRoute from '@widesk-ui/tools/createRoute';
import StandModel  from '@models/website/StandModel';

const route = createRoute.splitView(
	'/website_entertainments/:websiteEntertainmentId/stands/mode/:mode',
	'website',
	'StandSplitView',
	StandModel.localize('plural'),
);

export default route;
